import React, {useEffect, useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import  { Theme, createStyles, useTheme, TablePagination, TableFooter, TextField } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import { Button, ButtonGroup } from '@material-ui/core';
import { IonDatetime, IonIcon, IonLabel, IonSelect, IonSelectOption } from '@ionic/react';
import { DatePicker } from '@material-ui/pickers';
import ModalStandart from './Modal';
import Header from '../components/HeaderGenerico';
import { closeOutline} from "ionicons/icons";
import {CenteredGrid} from '../components/Grid';
import Grid from '@material-ui/core/Grid';
import EstadosGestionMarcacion from './GestionMarcacion/EstadosGestionMarcacion';
import OperariosRemplazos from 'src/services/operarioRemplazo';
import { useHistory } from 'react-router';
//import GestionTipoHora from './GestionTipoHora';
// import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
// import LastPageIcon from '@material-ui/icons/LastPage';
import { format } from 'date-fns';
import { ICalificaciones } from 'src/services/Fiscalizacion/Deposito';
import { fetchLP } from 'src/services/Fiscalizacion/Maquinas';
import GestionTipoHora from './GestionTipoHora';

const useRowStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: '#f5f5f5',
  },
  text:{
  color: 'black'
  },
  btnColor: {
    color: 'white'
  },
  historyContainer: {
    '@media (max-width: 600px)': {
      display: 'flex',
      flexDirection: 'column',
    }
  },
  headersTable: {
   
      display: 'flex',
      flexDirection: 'column',  
      backgroundColor: '#f5f5f5',
      border: '1px solid #e0e0e0', 
      padding: '0px 5px', 
      borderRadius: 5, 
      boxShadow: '0px 0px 10px #e0e0e0', 
    
  },
  input: {
    margin: theme.spacing(2),
  },
  button: {
    margin: theme.spacing(3),
    width: '87%',
    
  },
  box: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    width: '100%',
    backgroundColor: 'rgb(112, 4, 36)',
    borderEndEndRadius: '10px',
    borderEndStartRadius: '10px',
    boxShadow: '0px 0px 10px 0px rgba(0,0,0,0.75)',
    padding: '10px',
    marginBottom: '10px',
    border: '2px solid #900533',
    color: 'white',
    fontSize: '20px',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    letterSpacing: '1px',
    textAlign: 'center',
    boxSizing: 'border-box',  
    position: 'relative',
    zIndex: 1,
    overflow: 'hidden',
    transition: 'all 0.3s ease-in-out',
    backgroundImage: 'linear-gradient(to right, #900533, #900533)',
    backgroundSize: '200% 100%',
    backgroundPosition: 'right bottom',
    backgroundRepeat: 'no-repeat'  
    },
    inputSizes: {
      '& .MuiInputBase-root': {
        margin: theme.spacing(2),
        maxWidth: '100px'
      }
      },
    boxing: {
      display: 'flex',
      flexDirection: 'row',
      padding: '10px',
      boxSizing: 'border-box',
      position: 'relative',
      overflow: 'hidden',
      '& .MuiFormControl-root':{
        width: 150
      }
    }
}))

const useStyles1 = makeStyles((theme: Theme) =>
  createStyles({
    rootpag: {
      flexShrink: 0,
      marginLeft: theme.spacing(.5),
    },
  }),
);

type TablePaginationActionsProps = {
  count: number;
  page: number;
  rowsPerPage: number;
  onPageChange: (event: React.MouseEvent<HTMLButtonElement>, newPage: number) => void;
}

function TablePaginationActions(props: TablePaginationActionsProps) {
  const classes = useStyles1();
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  // const handleFirstPageButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
  //   onPageChange(event, 0);
  // };

  const handleBackButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    onPageChange(event, page + 1);
  };

  // const handleLastPageButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
  //   onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  // };

  return (
    <div className={classes.rootpag}>
     
      <IconButton onClick={handleBackButtonClick} disabled={page === 0} aria-label="previous page">
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      
    </div>
  );
}

function Row(props) {
  const { row, onDeleteRow  } = props;
  const [open, setOpen] = React.useState(false);
  const classes = useRowStyles();

  return (
    <React.Fragment>
      <TableRow className={classes.root}>
        <TableCell>
          <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row">
          {row.remplazante}
        </TableCell>
      </TableRow>
      <TableRow>
  <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
    <Collapse in={open} timeout="auto" unmountOnExit>
      <Box margin={1} className={classes.historyContainer}>
        <Typography variant="h6" gutterBottom component="div">
          Detalle
        </Typography>
        <Box display="flex" flexDirection="column">
          
                  <TableRow>Fecha Inicio: {row.fechaInicioRemplazante}</TableRow>
                  <TableRow>Fecha Fin: {row.fechaFinRemplazante}</TableRow>
                  <TableRow>Hora Entrada: {row.horaEntradaRemplazante}</TableRow>
                  <TableRow>Hora Salida: {row.horaSalidaRemplazante}</TableRow>
                  <TableRow style={{display:'flex', flexDirection:'column'}}>Dias: { row.dias}</TableRow>
                  <TableRow>Punto Servicio: <Typography> {row.puntoServicio}</Typography> </TableRow>
                  <Button variant="contained" color="primary" onClick={() => onDeleteRow()}>
                    Eliminar
                  </Button>
         
        </Box>
      </Box>
    </Collapse>
  </TableCell>
</TableRow>

    </React.Fragment>
  );
}
export function DataTableMaterial({ data, onDeleteRow}) {


  return (
    <TableContainer component={Paper}>
      <Table aria-label="collapsible table">
        <TableHead>
          <TableRow>
            <TableCell />
            <TableCell>Remplazante</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
        {data.map((row, index) => (
            <Row key={index} row={row} onDeleteRow={() => onDeleteRow(index)}/>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export const valorParaVistaRemp: {[key: string]: any} = []

function VistaRemp(props) {
  const { row, handleUpdate, handleLoadClick} = props;
  const [open, setOpen] = React.useState(false);
  const classes = useRowStyles();
  const [modalVisible, setModalVisible] = useState(false);
  const [fechaFinModificada, setFechaModificada] = React.useState<any>({
    fechaFinModificada: null,
  })
  const [showAlertActualizado, setShowAlertActualizado] = useState(false);
  const [mensajeRemplazoActualizado, setMensajeRemplazoActualizado] = useState('');

  const onOpenModal = () => {
    setModalVisible(true);
  };

  const onCloseModal = () => {
    setModalVisible(false);
  };


  const diasSemana = [
    { dia: 'lun', nombre: 'Lunes' },
    { dia: 'mar', nombre: 'Martes' },
    { dia: 'mie', nombre: 'Miércoles' },
    { dia: 'jue', nombre: 'Jueves' },
    { dia: 'vie', nombre: 'Viernes' },
    { dia: 'sab', nombre: 'Sábado' },
    { dia: 'dom', nombre: 'Domingo' },
  ];

  const bodyVistaRemplazo =(onClose, index) => (
    
    <>
    <Paper style={{zIndex: -1, justifyContent: 'center'}}>
    <Header width='100%' titulo='Mas detalles' marginTop='15px'  botonIzq={{ icono: closeOutline, action: onClose }} />
    <Box style={{marginLeft: 20}}>   
        <TableRow key={index}>
          <Typography>remplazante: {row.nombre_remplazo}</Typography>
          <br/>
          <Typography>remplazado: {row.nombre_remplazado}</Typography>
          <br/>
          <Typography>Fecha de Remplazos: {`${row.fecha_inicio} ~ ${row.fecha_fin}`}</Typography>
          <br/>
          <Typography>Punto Servicio: {row.nombre_ps}</Typography>
          <br/>
          {/* mostrar el motivo guardado del reemplazo */}
          <Typography>Motivo: {row.motivo || '-'}</Typography>
          <br/>
          <CenteredGrid  xs={12} text={row.nombre_ps} key={index} subGridItems={[diasSemana.map((dia, index) => (
        // Murestro los subgrid solo si 'dia.dia_ent' o 'dia.dia_sal' no son null
        (row[`${dia.dia}_ent`] !== null || row[`${dia.dia}_sal`] !== null) ? (
          <Grid xs={4} item key={index}>
            <Paper style={{backgroundColor: '#900533', opacity: 0.9, color:'white'}}>
              {`${dia.nombre}`}
              <br />
              {`${row ? row[`${dia.dia}_ent`] || '' : ''}`}
              <br />
              a
              <br />
              {`${row ? row[`${dia.dia}_sal`] || '' : ''}`}
            </Paper>
          </Grid>
        ) : null
      ))]}
    />
        </TableRow>  
        </Box>
    </Paper>
    </>
  )

  
 const handleModifyData = (index) => {
    const modifyRemp = row;
    const datos = { ...modifyRemp};
  
   

    if ('id' in datos) {
      const id = modifyRemp.id;
  
      // Convierte fechaFinModificada a un formato deseado
      const fechaFinMod = fechaFinModificada.fechaFinModificada;
      const formattedFechaFin = fechaFinMod;
  
      // Crea el objeto data con id y fechaFin
      const data = {
        id: id,
        fecha_fin: formattedFechaFin
      }
  
      //confirmar esta accion y luego enviar al endpoint la solicitud
     
      // eslint-disable-next-line no-restricted-globals
      const confirmar = confirm('¿Desea modificar la fecha de fin del remplazante?');
      if(confirmar){
        OperariosRemplazos.ActuializarRemplazoExistente(data).then(res => {
          try{
              const data = res.data;
              
                  setMensajeRemplazoActualizado(data.info)
                  setShowAlertActualizado(true)
                  handleLoadClick()
                setTimeout(() => {
                  setShowAlertActualizado(false);
                }, 15000);
                
            }catch(e){
               
                setShowAlertActualizado(true)
                setTimeout(() => {
                  setShowAlertActualizado(false);
                }, 15000);
              }
          });
      }
    } 
   
}
  
  const bodyModficar= (onClose, index) => (
    <>
  
    <Paper>
    <Header width='100%' textAlign='center' titulo='Modificar Fecha'  botonIzq={{ icono: closeOutline, action: () => {
          onClose && onClose();}
           }} />
    <IonLabel style={{marginTop:'2%', marginLeft:'10%'}}>Fecha</IonLabel>                     
          <DatePicker
            required
            className={classes.input}
            value={fechaFinModificada.fechaFinModificada ? new Date(fechaFinModificada.fechaFinModificada) : null}
            onChange={(date) => {
              setFechaModificada({...fechaFinModificada, fechaFinModificada: date?.toISOString().split('T')[0]})
            }}
            format="DD/MM/yyyy"
          />
          <Button key={index} className={classes.button} onClick={handleModifyData}>Guardar Modificacion</Button>

          {showAlertActualizado ? (
          <Alert severity='success' style={{ marginTop: '5px' }}>
            {mensajeRemplazoActualizado}
          </Alert>
        ) : null}

    </Paper>
    </>
  
  )

  return (
    <React.Fragment>
      <TableRow className={classes.root}>
        <TableCell>
          <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row">
          {row.nombre_ps}
        </TableCell>
      </TableRow>
      <TableRow>
    
  <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
    <Collapse in={open} timeout="auto" unmountOnExit>
      <Box margin={1} className={classes.historyContainer}>
      <ButtonGroup  disableElevation variant="contained" color="primary">
      <IonIcon size='large' name="search-outline" onClick={onOpenModal} />
      {modalVisible && (
        <ModalStandart className={classes.text} onClose={onCloseModal} body={bodyVistaRemplazo} text={'Ver mas detalles'} />
      )}
        </ButtonGroup>
        <Box display="flex" flexDirection="column">
                  <TableRow>Fecha Inicio: {row.fecha_inicio}</TableRow>
                  <TableRow>Fecha fin: {row.fecha_fin}</TableRow>
                  <TableRow>Remplazante: <Typography> {row.nombre_remplazo}</Typography></TableRow>
                  {/* fila para visualizar el motivo dentro del panel expandido */}
                  <TableRow>Motivo: <Typography> {row.motivo || '-'}</Typography></TableRow>
                  <ButtonGroup>
                  <Button style={{borderRadius: '4px'}} variant="contained" color="primary" onClick={() => handleUpdate()}>
                    Eliminar
                  </Button>
                  <Button style={{marginLeft: 15, borderRadius: '4px'}} variant="contained" color="primary">
                  <ModalStandart className={classes.btnColor} text={'MODIFICAR'} onClose={console.log('close')}  body={bodyModficar}></ModalStandart>
                  </Button>
                  </ButtonGroup>
        </Box>
        
      </Box>
    </Collapse>
  </TableCell>
</TableRow>

    </React.Fragment>
  );
}

export function DataTableVistaRemp({ data, handleUpdate}) {


  return (
    <TableContainer component={Paper}>
      <Table aria-label="collapsible table">
        <TableHead>
          <TableRow>
            <TableCell />
            <TableCell>Lista de Remplazos Existentes</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          
        {data.map((row, index) => (
            <VistaRemp key={index} row={row} handleUpdate={() => handleUpdate(index)} />
          ))}
        </TableBody>
      </Table>
   
    </TableContainer>
  );
}

function GestionMarcacionVista(props) { 
  const { row, cargo, nombreFiscal, legajo } = props;
  const [open, setOpen] = useState(false);
  const classes = useRowStyles();

  const formatName = (name:string) => {
    const [lasrName, firstName] = name.split(",");
    return `${firstName} ${lasrName}`;
  }
  const formattedName = formatName(nombreFiscal);

  console.log(formattedName)
  const handleToggle = () => {
    setOpen(!open);
  };

  const navigate = useHistory()


  const HandleMarcacionView = () => {
   navigate.push('/marcacion')
  }
  const HandleHorasProcesadasView = () => {
   navigate.push('/horasprocesadas')
  }

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  const handleChangePage = (event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <>
      <React.Fragment>

      <Box display="flex" justifyContent="space-evenly" marginTop={3}  marginBottom={2}>
              <Button variant="contained" color="primary" onClick={HandleMarcacionView}>
                MARCACIONES
              </Button>

              <Button variant="contained" color="primary" onClick={HandleHorasProcesadasView}>
                HORA PROCESADA
              </Button>
      </Box>
      
        <TableRow>

          <TableCell>
            <IconButton aria-label="expand row" size="small" onClick={handleToggle}>
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
            <br/>
           {open ? <>
           NORMAL: {row.registrosCupos['NORMA']}
           <br/>
           NOCTURNA: {row.registrosCupos['HNOCM']}
           <br/>
           DOMINGO: {row.registrosCupos['DOMIN']}
           <br/>
           DOMINGO NOC: {row.registrosCupos['DONOC']}
           <br/>
           FERIADO: {row.registrosCupos['FERIA']}
           <br/>
           FERIADO NOCTURNO: {row.registrosCupos['FENOC']}
           </> : 'VER DETALLES' 
           }
           
          </TableCell>
          
        </TableRow>
        
        <TableContainer  className={classes.root}>
        <Table>
        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box margin={1}>
              {(rowsPerPage > 0
                ? row.registrosDatos.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                : row.registrosDatos
                ).map((registro, index) => (
                  <>
                  {/* hasta este punto excluye al fiscal en cuestion que esta loggeado desde su telefono */}
                    {(formattedName !== registro.nombre && legajo !== registro.nroLegajo && cargo.includes('FISCAL')) && (
                      <div  key={index}>
                      <Typography>NOMBRE: {registro.nombre}</Typography>
                      <Typography>LEGAJO: {registro.nroLegajo}</Typography>
                      <Typography>FECHA: {registro.fecha}</Typography>
                      <Typography>ENTRADA: {registro.entrada}</Typography>
                      <Typography>SALIDA: {registro.salida}</Typography>
                      <Typography>ESTADO: {registro.estado}</Typography>
                      <Typography>TIPO: {registro.tipoHora}</Typography>
                      <Typography>MARCACION: {registro.tipoMarcacion}</Typography>
                      <Typography>TOTAL: {registro.total}</Typography>
                      {console.log('esto es info', row.registrosDatos.length as number)}
                      <EstadosGestionMarcacion item={{ estado: row.registrosDatos[index]?.estado }} info={row.registrosDatos[index]} />
                    </div>
                    )}
                    
                  </>
                  ))}
               </Box>
            </Collapse>
          </TableCell>
        </TableRow>
        <TableFooter>
        <TableRow>
        <TablePagination
              rowsPerPageOptions={[5, 10, 25, 50]}
              colSpan={3}
              count={row.registrosDatos.length}
              rowsPerPage={rowsPerPage}
              page={page}
              labelRowsPerPage="Lineas"
              labelDisplayedRows={({ from, to, count }) => `${from}-${to} ${count}`}
              SelectProps={{
                inputProps: { 'aria-label': 'lineas por pagina' },
                native: true,
              }}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
            />
          </TableRow>
          </TableFooter>
          </Table>
        </TableContainer>
      </React.Fragment>
    </>
  );
}


export function GestionMarcacionTabla(props) {

  const {data, cargo, nombreFiscal, legajo, onDeleteRow} = props;
 


  return (
    <TableContainer component={Paper}>
      <Table aria-label="collapsible table">
      
        <TableBody>
        {data.map((row, index) => (
            <GestionMarcacionVista key={index} 
            row={row}
            cargo={cargo}
            legajo={legajo}
            nombreFiscal={nombreFiscal}
            onDeleteRow={() => onDeleteRow(index)}/>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

function Marcacion(props) {
  const { row } = props;
  return (
    <>
      <React.Fragment>
        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
              <Box margin={1}>
                    <div key={row.index}>
                      <Typography>OPERACION: {row.operacion}</Typography>
                      <Typography>NOMBRE: {row.nombre}</Typography>
                      <Typography>LEGAJO: {row.legajo}</Typography>
                      <Typography>CEDULA: {row.cedula}</Typography>
                      <Typography>PUNTO DE SERVICIO: {row.puntoServicio}</Typography>
                      <Typography>FECHA: {row.fecha}</Typography>
                      <Typography>HORA: {row.hora}</Typography>
                      <Typography>ESTADO: {row.estado}</Typography>
                    
                    </div>
               </Box>
          </TableCell>
        </TableRow>
      </React.Fragment>
    </>
  );
}


export function MarcacionTabla(props) {

  const {data} = props;
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  const handleChangePage = (event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <TableContainer component={Paper}>
      <Table aria-label="collapsible table">
      <Header titulo="Marcaciones"/>
        <TableBody>

        {(rowsPerPage > 0
            ? data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            : data
          ).map((row, index) => (
            <Marcacion key={index} 
            row={row} 
            />
          ))}
        </TableBody>
        <TablePagination
              rowsPerPageOptions={[5, 10, 25, { label: 'Todos', value: -1 }]}
              colSpan={6}
              count={data.length}
              rowsPerPage={rowsPerPage}
              page={page}
              labelRowsPerPage="Lineas"
              labelDisplayedRows={({ from, to, count }) => `${from}-${to}`}
              SelectProps={{
                inputProps: { 'aria-label': 'lineas por pagina' },
                native: true,
              }}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
            />
      </Table>
    </TableContainer>
  );
}

function HoraProcesada(props) {
  const { row } = props;
  // Verifica si row.data está definido y tiene la propiedad info antes de acceder a row.data.info
  const infoData = row.data && row.data.info ? row.data.info : [];

  console.log('soy los datos en tabla info: ', infoData);
  return (
    <>
      <React.Fragment>
        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
              <Box margin={1}>
              <div key={row}>
                      <Typography>NOMBRE: {row.nombre}</Typography>
                      <Typography>LEGAJO: {row.legajo}</Typography>
                      <Typography>CEDULA: {row.cedula}</Typography>
                      <Typography>Codigo P.S: {row.pscodigo}</Typography>
                      <Typography>PUNTO DE SERVICIO: {row.puntoServicio}</Typography>
                      <Typography>FECHA: {row.fecha}</Typography>
                      <Typography>HORARIO: {row.horario}</Typography>
                      <Typography>TIPO: {row.tipohora}</Typography>
                      <GestionTipoHora info={row['datos']} />  
                      
                    </div>
               </Box>
          </TableCell>
        </TableRow>
      </React.Fragment>
    </>
  );
}

export function HoraProcesadaTabla(props) {

  const {data} = props;
  console.log('soy los datos en tabla: ', data)
  const classes = useRowStyles();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  const handleChangePage = (event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <TableContainer component={Paper}>
         <Header titulo="HORAS PROCESADAS"/>
      <Table aria-label="collapsible table">
   
      <TableHead style={{width: '100%'}}>
                <Box className={classes.box}>
                    <Typography style={{color:'white'}}>Horas Diurnas: {data?.['horas']?.norma}  </Typography>
                    <br/>
                    <Typography style={{color:'white'}}>Horas Nocturnas: {data?.['horas']?.hnoc} </Typography>
                    <br/>
                    <Typography style={{color:'white'}}>Domingo Diurnas: {data?.['horas']?.domin} </Typography>
                    <br/>
                    <Typography style={{color:'white'}}>Domingo Nocturnas: {data?.['horas']?.donoc} </Typography>
                    <br/>
                    <Typography style={{color:'white'}}>Feriado Diurnas: {data?.['horas']?.feria} </Typography>
                    <br/>
                    <Typography style={{color:'white'}}>Feriado Nocturnas: {data?.['horas']?.fenoc} </Typography>
                    <br/>
                    <Typography style={{color:'white'}}>50%: {data?.['horas']?.cincuenta} </Typography>
                    <br/>
                </Box>
      </TableHead>
        <TableBody>

        {(data.info && data.info.length > 0) ? (
          (rowsPerPage > 0
            ? data.info.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            : data.info
          ).map((item, index) => (
            <HoraProcesada 
              key={index} 
              row={item}
            />
          ))
        ) : (
          // Puedes manejar el caso en el que data.info es undefined
          // Puedes mostrar un mensaje de error o simplemente no renderizar nada aquí
          <></>
        )}
    


        </TableBody>
        
        <TablePagination
              rowsPerPageOptions={[5, 10, 25, 50]}
              colSpan={3}
              count={data.info ? data.info.length : 0}
              rowsPerPage={rowsPerPage}
              page={page}
              labelRowsPerPage="Lineas"
              labelDisplayedRows={({ from, to, count }) => `${from}-${to} (${count})`}
              SelectProps={{
                inputProps: { 'aria-label': 'lineas por pagina' },
                native: true,
              }}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
            />
      </Table>
    </TableContainer>
  );
}

function InformacionGenerica({ row, index, handleCantidadChange, handlePorcentajeChange, handleEliminar }) {
  const classes = useRowStyles();
    const [cantidad, setCantidad] = useState('');
  const [porcentaje, setPorcentaje] = useState('');

  useEffect(() => {
    // Se muestran los valores de la fila sin importar el origen: los productos
    // agregados desde el catálogo entran con porcentaje 100 por defecto y antes
    // quedaban con los campos vacíos.
    setCantidad(row.CantidadStock || ''); // Carga el valor si existe, o deja vacío
    setPorcentaje(row.porcentaje || ''); // Carga el valor si existe, o deja vacío
  }, [row]);

    // Funciones para manejar cambios en cantidad y porcentaje
    const onCantidadChange = (e) => {
      setCantidad(e.target.value)
      handleCantidadChange(e.target.value, index);
    };

    const onPorcentajeChange = (e) => {
      setPorcentaje(e.target.value)
      handlePorcentajeChange(e.target.value, index);
    };

  return (
    <React.Fragment>
    <TableRow>
      <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6} >
        <Box overflow={'hidden'} display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6" gutterBottom component="div">
            {row.CodItem}
          </Typography>
          {handleEliminar && (
            <Button
              size="small"
              variant="outlined"
              style={{ color: '#8C0032', borderColor: '#8C0032' }}
              onClick={() => handleEliminar(index)}
            >
              Quitar
            </Button>
          )}
        </Box>
          <Box
            maxWidth={200}
            padding={1}
          >
            <TableRow>Descripción: {row.DescripcionItem}</TableRow>
            <br />
          </Box>
          <Box className={classes.boxing}>
            <TextField
              size="small"
              id="outlined-number-cantidad"
              label="Cantidad:"
              type="number"
              className={classes.inputSizes}
              value={cantidad}
              onChange={onCantidadChange}
              InputLabelProps={{
                shrink: true,
              }}
              variant="outlined"
            />
          
          <br />
         
            <TextField
              id="outlined-number-porcentaje"
              label="Porcentaje:"
              type="number"
              className={classes.inputSizes}
              value={porcentaje}
              onChange={onPorcentajeChange}
              InputLabelProps={{
                shrink: true,
              }}
              variant="outlined"
             
            />
          </Box>
        
      </TableCell>
    </TableRow>
  </React.Fragment>
  );
}



export function TablaGenerica({ data, handleCantidadChange, handlePorcentajeChange, handleEliminar }) {
  return (
    <TableContainer component={Paper} variant='outlined' elevation={7} style={{ maxWidth: '100%', overflowX: 'auto' }}>
      <Table aria-label="collapsible table" >
        <TableHead>
          <TableRow>
            <TableCell />
            <TableCell>Información</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row, index) => (
            <InformacionGenerica
              key={index}
              row={row}
              index={index}
              handleCantidadChange={handleCantidadChange}
              handlePorcentajeChange={handlePorcentajeChange}
              handleEliminar={handleEliminar}
            />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}


function InformacionLP({ row, index, handleFechaChange, handleEstadoChange }) {
  const classes = useRowStyles();
  const [isSubmitted] = useState(false);
  const [estados, setEstados] = useState<ICalificaciones[]>([]);
  const [estadoSeleccionado, setEstadoSseleccionado] = useState('')

  useEffect(() => {
    const calificaciones = async () => {
      const response = await fetchLP();
      if (!response.error) {
        const { datos } = response;
        setEstados(datos as []);
      } else {
        console.error('Error al obtener calificaciones:', response.error);
        // Manejar el error de alguna manera, por ejemplo, mostrando un mensaje al usuario
      }
    } 
    calificaciones();
  }, []);

    // Funciones para manejar cambios en cantidad y porcentaje
    const onFechaChange = (e) => {
      handleFechaChange(e.split('T')[0], index);
    };
  
    const onEstadoChange = (e: CustomEvent) => {   
      handleEstadoChange(e.detail.value, index);
      setEstadoSseleccionado(e.detail.value)
    };

    // Ajustar la fecha para tener en cuenta la zona horaria local
    const adjustedDate = new Date(row.fecha);
    adjustedDate.setUTCHours(adjustedDate.getUTCHours() + adjustedDate.getTimezoneOffset() / 60);
    const formattedAdjustedDate = format(adjustedDate, 'yyyy-MM-dd');
    
    const estadoNombre = estados.find(estado => estado.estado === row.estado)?.estado || '';

  return (
    <React.Fragment>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Box margin={1} className={classes.historyContainer}>
            <Typography variant="h6" gutterBottom component="div">
              {row.tipo_lavado}
            </Typography>
            <Box display="flex" flexDirection='row'>
              <TableCell>
                <TableRow>codigo: {row.codigo}</TableRow>
                <br/>
                <TableRow>Cantidad de horas: {row.cant_horas}</TableRow>
                <br/>
                <TableRow>Frecuencia: {row.frecuencia}</TableRow>
                <br/>
                <TableRow>Fecha: {formattedAdjustedDate }</TableRow>
                <br/>
                <TableRow>Estado: {estadoNombre}</TableRow>
                <br/>
              </TableCell>
              <TableCell>
              <h4>Plazo para gestionar</h4>  
              <br/>
              <IonLabel position="stacked">Fecha de gestion:</IonLabel>
                <TableRow style={{ borderWidth: 1, borderColor: 'gray', borderRadius: 5 }}>
                <IonDatetime
                    displayFormat="YYYY-MM-DD"
                    value={row.fecha}
                    onIonChange={(e) => onFechaChange(e.detail.value)}
                  />
                </TableRow>
                <br />
                <TableRow>
                  estado:
                  <IonSelect
                    placeholder="Estado"
                    interface="action-sheet"
                    onIonChange={onEstadoChange}
                    value={estadoSeleccionado}
                    className={isSubmitted && !estados ? "campo-obligatorio" : ""}
                  >
                    {estados.map((estado) => (
                      <IonSelectOption onChange={(e) => setEstadoSseleccionado(e.currentTarget.value)} key={estado.id} value={estado.id.toString()}>
                        {estado.estado}
                      </IonSelectOption>
                    ))}
                  </IonSelect>     
                </TableRow>
              </TableCell>
            </Box>
          </Box>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}


export function TablaLP({ data, handleEstadoChange, handleFechaChange }) {
  return (
    <TableContainer component={Paper}>
      <Table aria-label="collapsible table">
        <TableHead>
          <TableRow>
            <TableCell />
            <TableCell>Informacion</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row, index) => (
            <InformacionLP
              key={index}
              row={row}
              index={index}
              handleEstadoChange={handleEstadoChange}
              handleFechaChange={handleFechaChange}
            />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
